import { gql } from "@apollo/client";

export const GET_FEATURE_BANNERS = gql`
  query GetAllFeatureBanners($limit: Int = 20, $offset: Int = 0) {
    featureBanners(limit: $limit, offset: $offset) {
      id
      placement
      status
      audience
      title
      message
      ctaLabel
      deeplink
      externalUrl
      minAppVersion
      maxAppVersion
      platforms
      startsAt
      endsAt
      dismissible
      variant
      icon
      createdAt
      updatedAt
    }
  }
`;

export const CREATE_FEATURE_BANNER = gql`
  mutation CreateFeatureBanner(
    $status: BannerStatus
    $audience: BannerAudience
    $title: String
    $message: String!
    $ctaLabel: String
    $deeplink: String
    $externalUrl: String
    $minAppVersion: String
    $maxAppVersion: String
    $platforms: [String]
    $startsAt: Date
    $endsAt: Date
    $dismissible: Boolean
    $variant: BannerVariant
    $icon: String
  ) {
    createFeatureBanner(
      status: $status
      audience: $audience
      title: $title
      message: $message
      ctaLabel: $ctaLabel
      deeplink: $deeplink
      externalUrl: $externalUrl
      minAppVersion: $minAppVersion
      maxAppVersion: $maxAppVersion
      platforms: $platforms
      startsAt: $startsAt
      endsAt: $endsAt
      dismissible: $dismissible
      variant: $variant
      icon: $icon
    ) {
      id
    }
  }
`;

export const UPDATE_FEATURE_BANNER = gql`
  mutation UpdateFeatureBanner(
    $id: ID!
    $status: BannerStatus
    $audience: BannerAudience
    $title: String
    $message: String
    $ctaLabel: String
    $deeplink: String
    $externalUrl: String
    $minAppVersion: String
    $maxAppVersion: String
    $platforms: [String]
    $startsAt: Date
    $endsAt: Date
    $dismissible: Boolean
    $variant: BannerVariant
    $icon: String
  ) {
    updateFeatureBanner(
      id: $id
      status: $status
      audience: $audience
      title: $title
      message: $message
      ctaLabel: $ctaLabel
      deeplink: $deeplink
      externalUrl: $externalUrl
      minAppVersion: $minAppVersion
      maxAppVersion: $maxAppVersion
      platforms: $platforms
      startsAt: $startsAt
      endsAt: $endsAt
      dismissible: $dismissible
      variant: $variant
      icon: $icon
    ) {
      id
    }
  }
`;

export const DELETE_FEATURE_BANNER = gql`
  mutation DeleteFeatureBanner($id: ID!) {
    deleteFeatureBanner(id: $id) {
      id
    }
  }
`;
